// Chakra imports
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
// Custom components
import BarChart from 'components/charts/BarChart';
import { numberToHour } from 'utils';
import { stackedBarChartOptions } from 'variables/charts';

// Heures d'intervention par mois, empilées selon le type de forfait (horaire ou annuel)
export default function HoursByMonth(props: {
	labels: string[];
	hourly: number[];
	annual: number[];
	total: number;
	[x: string]: any;
}) {
	const { labels, hourly, annual, total, ...rest } = props;

	// Chakra Color Mode
	const textColor = useColorModeValue('secondaryGray.900', 'white');

	const chartData = [
		{ name: 'Forfaits horaires', data: hourly },
		{ name: 'Forfaits annuels', data: annual }
	];
	const chartOptions = {
		...stackedBarChartOptions,
		xaxis: { ...stackedBarChartOptions.xaxis, categories: labels },
		tooltip: { ...stackedBarChartOptions.tooltip, y: { formatter: numberToHour } },
		legend: { show: true, position: 'top', horizontalAlign: 'right', labels: { colors: '#A3AED0' } }
	};

	return (
		<Card alignItems='center' flexDirection='column' w='100%' {...rest}>
			<Flex align='center' w='100%' px='15px' py='10px'>
				<Text me='auto' color={textColor} fontSize='xl' fontWeight='700' lineHeight='100%'>
					Heures d'intervention par mois
				</Text>
				<Text color='secondaryGray.600' fontSize='sm' fontWeight='500'>
					{numberToHour(total)} sur 12 mois
				</Text>
			</Flex>

			<Box h='240px' mt='auto' w='100%'>
				<BarChart chartData={chartData} chartOptions={chartOptions} />
			</Box>
		</Card>
	);
}
